import React, { useContext, useEffect, useState } from 'react';
import { Avatar } from '@mui/material';

import DefaultAvatar from '../../../Common/Images/default-avatar.jpg';

import { decodeJwt } from '../../../utils';

import { AuthContext } from '../../../constants';

import LogoutUIWrapper from '../Logout';

export default function LogoutButton() {
  const { userInfo } = useContext(AuthContext);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const profileName = userInfo?.name;

  useEffect(() => {
    if (!userInfo?.accessToken) return;

    const decoded = decodeJwt(userInfo.accessToken);
    const pic = decoded?.picture;

    if (pic) {
      setAvatarUrl(pic);
    } else {
      setAvatarUrl(null);
    }
  }, [userInfo?.accessToken]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        className="user-circle"
        type="button"
        onClick={handleClick}
        style={{ border: 'none', background: 'transparent' }}
      >
        <Avatar
          src={avatarUrl}
          alt={profileName}
          onError={() => setAvatarUrl(DefaultAvatar)}
          sx={{ width: 32, height: 32, fontSize: 16 }}
          imgProps={{ referrerPolicy: 'no-referrer' }}
        >
          {profileName ? profileName[0] : '/'}
        </Avatar>
      </button>
      <LogoutUIWrapper anchorEl={anchorEl} handleClose={handleClose} />
    </>
  );
}
